import type { ReactElement } from 'react';
import useAppLocation from '../useAppLocation.ts';
import ParticipantDetailsSkeleton from '../../views/leaderboard/components/details/components/participant-details/ParticipantDetails.skeleton.tsx';
import { DivSkeleton } from '@fastnorth/kraken/components/layout';
import AwardsSkeleton from '../../views/awards/Awards.skeleton.tsx';
import EventProgressSkeleton from '../../views/event-progress/EventProgress.skeleton.tsx';
import LeaderboardSkeleton from '../../views/leaderboard/Leaderboard.skeleton.tsx';
import HomeSkeleton from '../../views/home/Home.skeleton.tsx';
import FollowingSkeleton from '../../views/following/Following.skeleton.tsx';
import StatisticsSkeleton from '../../views/statistics/Statistics.skeleton.tsx';
import FilmstripSkeleton from '../../views/components/film-strip/Filmstrip.skeleton.tsx';

const ContextualLoadingSkeleton = (): ReactElement => {
  const {
    isLeaderboard,
    isDetails,
    isAwards,
    isProgress,
    isHome,
    isFollowing,
    isStatistics,
    isPhotos,
  } = useAppLocation();
  if (isDetails) {
    return <ParticipantDetailsSkeleton />;
  }

  if (isLeaderboard) {
    return <LeaderboardSkeleton />;
  }

  if (isAwards) {
    return <AwardsSkeleton />;
  }

  if (isProgress) {
    return <EventProgressSkeleton />;
  }

  if (isHome) {
    return <HomeSkeleton />;
  }

  if (isFollowing) {
    return <FollowingSkeleton />;
  }

  if (isStatistics) {
    return <StatisticsSkeleton />;
  }

  if (isPhotos) {
    return <FilmstripSkeleton />;
  }

  return <DivSkeleton className={'w-auto h-[100px]'} />;
};

export default ContextualLoadingSkeleton;
